import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=94a6b3b8&scoped=true&"
import script from "./import-file.vue?vue&type=script&lang=js&"
export * from "./import-file.vue?vue&type=script&lang=js&"
import style0 from "./import-file.vue?vue&type=style&index=0&id=94a6b3b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a6b3b8",
  null
  
)

export default component.exports